// packages/api-client/queries/entries/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createEntriesQueries = (requests, queryClient) => ({
    useListEntries: (params, options = {}) => useQuery({
        queryKey: ["entries", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listEntries(params);
        },
        ...options,
    }),
    useFindEntry: (params, options = {}) => useQuery({
        queryKey: ["entries", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findEntry(params);
        },
        ...options,
    }),
    useListEntryAssignableBreweries: (params, options = {}) => useQuery({
        queryKey: ["entries", "assignable-breweries", params?.id],
        queryFn: () => requests.listEntryAssignableBreweries({ id: params?.id }),
        ...options,
    }),
    useCheckEntryNameUniqueness: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.checkEntryNameUniqueness,
    }),
    useRegisterEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.registerEntry,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useRecodeEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.recodeEntry(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    usePromoteEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.promoteEntry(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useMarkEntryAsSent: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.markEntryAsSent(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useMarkEntryAsPaid: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.markEntryAsPaid(entryAttrs);
        },
    }),
    useMarkEntryAsJudged: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.markEntryAsJudged(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useReEvaluateEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.reEvaluateEntry(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useGenerateRecodeTokens: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.downloadRecodeTokens(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDownloadEntryProforma: (options = {}) => useMutation({
        ...options,
        mutationFn: (payload) => {
            return requests.downloadEntryProforma(payload);
        },
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
    useGenerateEntryLabels: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.downloadEntryLabels(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
    useGenerateEntriesReport: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.generateEntriesReport(attrs);
        },
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
    useGenerateFinalistsReport: (options = {}) => useMutation({
        ...options,
        mutationFn: (attrs) => {
            return requests.generateFinalistsReport(attrs);
        },
        onSuccess: (data, variables, context) => {
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDemoteEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.demoteEntry(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDeleteEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.deleteEntry(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useCheckOutEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.checkOutEntry(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stages"],
            });
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-styles"],
            });
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stage-table-entries"],
            });
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useCheckInEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: (entryAttrs) => {
            return requests.checkInEntry(entryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stages"],
            });
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-styles"],
            });
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stage-table-entries"],
            });
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.updateEntry,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useCancelEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.cancelEntry,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    usePreJudgeCheck: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.preJudgeCheck,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDecideTableEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.decideTableEntry,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDisqualifyEntry: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.disqualifyEntry,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["entries"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useSyncEntries: (options = {}) => {
        return useMutation({
            ...options,
            mutationFn: requests.syncEntries,
            onSuccess: (data, variables, context) => {
                if (!variables.dryRun) {
                    queryClient.invalidateQueries({ queryKey: ["entries"] });
                }
                options.onSuccess?.(data, variables, context);
            },
        });
    },
});
//# sourceMappingURL=index.js.map